import { Col, Form, Row } from "reactstrap";
import { Btn, H3, H4, H5 } from "../../../../../../AbstractElements";
import { useEffect, useState } from "react";
import { AssetsNonPropertyFormData, AssetsNonPropertyFormErrors } from "../../../FormData";
import DollarInput from "../../../../../common/DollarInput";
import { Button } from "reactstrap";
import { useMutationRequestQuery } from "../../../../../../Hooks/useMutationRequestQuery";
import { updateClientAssetsService } from "../../../../../../Services/PublicPageServices";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setFormStatus } from "../../../../../../ReduxToolkit/Reducers/FromStatusSlice";
import { Continue } from "../../../../../../Utils/Constants";
import { RootState } from "../../../../../../ReduxToolkit/Store";
import { useSelector } from "react-redux";
import { setFormsData } from "../../../../../../ReduxToolkit/Reducers/FormDataSlice";
import { updateFormData } from "../../../../../../ReduxToolkit/Reducers/FactFindDataSlice";

export default function AssetsNonProperty({ activeCallBack, clientId, setClientId }: any) {
    const [formData, setFormData] = useState<any>(AssetsNonPropertyFormData);
    const [formErrors, setFormErrors] = useState<any>(AssetsNonPropertyFormErrors);
    const dispatch = useDispatch()

    // Validate functions for each field (modify these as per actual validation requirements)
    const validateStringField = (value: string) => value.trim() !== ''; // simple non-empty validation for string fields


    const { mutate: updateClientAssets, isPending: isUpdateClientAssetsPending } = useMutationRequestQuery(
        'updateClientAssetsService',
        updateClientAssetsService,
        {
            onSuccess: (data: any) => {
                toast.success("Assets non-property information submitted successfully.");
                dispatch(setFormStatus({ id: '5', status: 5 }));
                setFormErrors(AssetsNonPropertyFormErrors);
                activeCallBack(6);
            },
            onError: (error: any) => {
                toast.error("Failed to submit assets non-property information");
                console.error(error);
                setFormErrors(error?.response?.data || {});
            },
        }
    );

    useEffect(() => {
        dispatch(setFormsData({
            id: '5',
            formData: formData,
        }));
    }, [formData])

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        // Validate each non-property field
        const nonPropertyCashinBankValid = validateStringField(formData.nonPropertyCashinBank);
        const nonPropertyContentsValid = validateStringField(formData.nonPropertyContents);
        const nonPropertyBusinessValueValid = validateStringField(formData.nonPropertyBusinessValue);
        const nonPropertyCryptoCurrencyValid = validateStringField(formData.nonPropertyCryptoCurrency);
        const nonPropertySuperClient1Valid = validateStringField(formData.nonPropertySuperClient1);
        const nonPropertySuperClient2Valid = validateStringField(formData.nonPropertySuperClient2);
        const nonPropertySMSFValid = validateStringField(formData.nonPropertySMSF);

        const isValid =
            nonPropertyCashinBankValid &&
            nonPropertyContentsValid &&
            nonPropertyBusinessValueValid &&
            nonPropertyCryptoCurrencyValid &&
            nonPropertySuperClient1Valid &&
            nonPropertySuperClient2Valid &&
            nonPropertySMSFValid;

        // If any validation fails, set errors for each field
        setFormErrors({
            nonPropertyCashinBank: !nonPropertyCashinBankValid,
            nonPropertyContents: !nonPropertyContentsValid,
            nonPropertyBusinessValue: !nonPropertyBusinessValueValid,
            nonPropertyCryptoCurrency: !nonPropertyCryptoCurrencyValid,
            nonPropertySuperClient1: !nonPropertySuperClient1Valid,
            nonPropertySuperClient2: !nonPropertySuperClient2Valid,
            nonPropertySMSF: !nonPropertySMSFValid,
        });

        // If form is valid, proceed to the next step

        if (clientId != 0) {
            dispatch(
                updateFormData({
                  formName: "assetsNonProperty",
                  formData: formData,
                })
              );
            updateClientAssets({ ...formData, clientID: clientId })
        }

    };

    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleErrorChange = (name: string, error: boolean) => {
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    return (
        <>
            <Form
                style={{
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    padding: '30px',
                    backgroundColor: '#fff',
                }}
                onSubmit={handleSubmit}
            >
                <Row className='g-3'>
                    <Col xs={6} className='mb-4 text-left'>
                        <H3 className='f-w-900 heading-color'>Assets-Non-Property</H3>
                    </Col>
                    <Col xs={6} className="text-end">
                        <Btn color="primary" style={{ fontSize: '18px' }} className='me-2' onClick={() => activeCallBack(4)}>
                            Previous
                        </Btn>
                        <Button
                            type="button"
                            color="success"
                            disabled={isUpdateClientAssetsPending}
                            onClick={handleSubmit}
                            style={{ fontSize: '18px' }}
                        >
                            {isUpdateClientAssetsPending ? "Loading . . ." : Continue}
                        </Button>
                        </Col>

                </Row>

              

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertyCashinBank"
                        value={formData.nonPropertyCashinBank}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Cash in Bank"
                        passCol="col-3"

                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertyContents"
                        value={formData.nonPropertyContents}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Contents"
                        passCol="col-3"
                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertyBusinessValue"
                        value={formData.nonPropertyBusinessValue}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Business Value"
                        passCol="col-3"
                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertyCryptoCurrency"
                        value={formData.nonPropertyCryptoCurrency}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Crypto Currency"
                        passCol="col-3"
                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertySuperClient1"
                        value={formData.nonPropertySuperClient1}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Super Client 1"
                        passCol="col-3"
                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertySuperClient2"
                        value={formData.nonPropertySuperClient2}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="Super Client 2"
                        passCol="col-3"
                    />
                </Col>

                <Col sm={10} className='sm-row' >
                    <DollarInput
                        name="nonPropertySMSF"
                        value={formData.nonPropertySMSF}
                        setValue={handleValueChange}
                        required={false}
                        limit={8}
                        design="flex"
                        label="SMSF"
                        passCol="col-3"
                    />

                </Col>

          
            </Form >
        </>
    );
}
